/* eslint-disable react/require-default-props,react/destructuring-assignment */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { autobind } from 'core-decorators';
import CSSModules from 'react-css-modules';
import classNames from 'classnames';

import Modal from '../Modal';
import styles from './index.styl';

export const imagePreviewClass = 'image-viewer-img';

@CSSModules(styles)
export default class ImageViewer extends Component {
  static propTypes = {
    config: PropTypes.shape({
      src: PropTypes.string,
      opened: PropTypes.bool,
    }),
    onClose: PropTypes.func,
  };

  image = null;

  componentDidUpdate(prevProps) {
    if (this.props.config.opened && !prevProps.config.opened) {
      if (this.image) {
        this.image.addEventListener('load', e =>
          e.target.classList.remove('o-0'),
        );
      }
    }
  }

  @autobind
  handleClose() {
    this.image.classList.add('o-0');
    setTimeout(this.props.onClose, 100);
  }

  render() {
    const {
      config: { src, opened },
    } = this.props;

    if (!opened) return null;

    return (
      <Modal>
        <div
          styleName="root"
          className="df al-c justify-center"
          onClick={this.handleClose}
        >
          <img
            alt="preview viewer"
            ref={node => (this.image = node)}
            className={classNames(imagePreviewClass, 'o-0')}
            src={src}
            onContextMenu={e => e.preventDefault()}
          />
          <div styleName="backdrop" />
        </div>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/common/ImageViewer/index.jsx